import { useEffect, useState } from "react";
import { OrganizationPublic } from "../models/shared/Organization";
import config from "../utils/config";

interface Props {
    orgId: string;
}

export const usePublicOrganization = (props: Props) => {
    const [publicOrg, setPublicOrg] = useState<OrganizationPublic | null>(null);

    useEffect(() => {
        if (!props.orgId) {
            return;
        }

        const endpoint = config.functions.getPublicOrganization + '?orgId=' + props.orgId;
        fetch(endpoint).then((response) => {
            if (response.status !== 200) {
                console.error('Error fetching public organization data:', response.statusText);
            }
            return response.json();
        }).then((data) => {
            setPublicOrg(data.org);
        });;

    }, [props.orgId])

    return publicOrg;
}